import React, { useEffect, useState } from "react";
import { Sparkles, Loader2, Star } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { paymentsAPI } from "../lib/api";
import { toast } from "sonner";

// Inline "Promuovi" button + dialog with package choices, paid via Stripe Checkout.
export default function PromoteListingButton({ listing }) {
  const [open, setOpen] = useState(false);
  const [packages, setPackages] = useState({});
  const [selected, setSelected] = useState("vetrina_7d");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && Object.keys(packages).length === 0) {
      paymentsAPI.packages().then(setPackages).catch(() => {});
    }
  }, [open, packages]);

  const startCheckout = async () => {
    setLoading(true);
    try {
      const origin = window.location.origin;
      const { url } = await paymentsAPI.createSession(selected, listing.id, origin);
      if (!url) throw new Error("URL Stripe mancante");
      window.location.href = url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore avvio pagamento");
      setLoading(false);
    }
  };

  if (listing.featured) {
    return (
      <span className="inline-flex items-center gap-1 text-amber-700 bg-amber-100 px-2 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider">
        <Star className="w-3 h-3 fill-amber-500 stroke-amber-700" /> In Vetrina
      </span>
    );
  }

  return (
    <>
      <Button
        size="sm"
        onClick={() => setOpen(true)}
        className="bg-amber-500 hover:bg-amber-600 text-white rounded-full h-8 px-3 text-xs"
        data-testid={`promote-button-${listing.id}`}
      >
        <Sparkles className="w-3.5 h-3.5 mr-1" /> Promuovi
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-[#1d3d3a]">
              <Sparkles className="w-5 h-5 text-amber-500" /> Vetrina Premium
            </DialogTitle>
            <DialogDescription>
              Metti il tuo annuncio in evidenza nella home, in cima ai risultati di ricerca e nella categoria.
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-2">
            {Object.entries(packages).map(([id, pkg]) => (
              <button
                key={id}
                onClick={() => setSelected(id)}
                className={`w-full text-left rounded-2xl border-2 p-4 transition-all ${
                  selected === id
                    ? "border-amber-500 bg-amber-50"
                    : "border-slate-200 bg-white hover:border-amber-300"
                }`}
                data-testid={`package-${id}`}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-black text-[#1d3d3a]">{pkg.label}</div>
                    <div className="text-xs text-slate-500 mt-0.5">
                      Annuncio in evidenza per {pkg.duration_days} giorni
                    </div>
                  </div>
                  <div className="text-xl font-black text-amber-600">€{pkg.amount}</div>
                </div>
              </button>
            ))}
          </div>

          <div className="text-[11px] text-slate-500 bg-slate-50 rounded-lg p-3 leading-relaxed">
            🔒 Pagamento sicuro con <strong>Stripe</strong>. Carte di credito, debito, Apple Pay e Google Pay supportate.
            Verrai reindirizzato al checkout di Stripe.
          </div>

          <div className="flex gap-2 justify-end">
            <Button variant="outline" onClick={() => setOpen(false)} disabled={loading}>Annulla</Button>
            <Button onClick={startCheckout} disabled={loading || !selected} className="bg-amber-500 hover:bg-amber-600 text-white" data-testid="confirm-checkout-button">
              {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin"/> : <Sparkles className="w-4 h-4 mr-2"/>}
              {loading ? "Reindirizzamento…" : "Paga e promuovi"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
